const PeopleView = ({company}) => {
    return "VIEEEEWWWWW People";
  };
  
  export default PeopleView;
  